import React from 'react';
export var SidePageContext = /*#__PURE__*/React.createContext({
  requestClose: function requestClose() {
    return undefined;
  },
  getWidth: function getWidth() {
    return 'auto';
  },
  updateLayout: function updateLayout() {
    return undefined;
  },
  footerRef: function footerRef() {
    return undefined;
  }
});
SidePageContext.displayName = 'SidePageContext';